import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import { Modal } from 'react-overlays'
import { FormattedMessage, injectIntl } from 'react-intl'
import { inlineLexer } from 'marked'

import { Link } from './localizedlink'
import { submitNewsletter } from '../utility/rest'
import { gtag, findLocalized, EMAIL_REGEX } from '../utils';

class Newsletter extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      email: '',
      showModal: false,
      success: false,
      error: null
    }
  }

  validateEmail(){
    if (EMAIL_REGEX.test(this.state.email)){
      this.setState({
        error: null
      });
      return true;
    }else{
      this.setState({
        error: 'email-invalid'
      });
      return false;
    }
  }

  async submit(e) {
    e.preventDefault();
    if (!this.validateEmail()){
      return;
    }
    gtag();
    this.setState({
      showModal: true,
      success: false
    });
    try {
      await submitNewsletter(this.state.email);
      this.setState({
        success: true
      });
    } catch (err) {
      console.error('Error ', err);
      let serverMessage = null;
      if (err.response && err.response.data && err.response.data.serverMessage){
        serverMessage = err.response.data.serverMessage;
      }
      this.setState({
        showModal: false,
        success: false,
        error: serverMessage
      });
    }
  }

  onChange(e) {
    const { name, value } = e.target;
    this.setState({
      [name]: value
    }, () => {
      if (this.state.error){
        this.validateEmail();
      }
    });
  }

  close() {
    this.setState({ showModal: false, success: false });
  }

  render() {
    const { email, showModal, success, error } = this.state;
    const { intl: {locale}} = this.props;
    return <StaticQuery
      query={graphql`
        query {
          workshop: file(relativePath: {eq: "iic-icon.png"}){
            childImageSharp{
              fluid{
                ...GatsbyImageSharpFluid
              }
            }
          }   
          allNewsletterYaml{
            edges{
              node{
                title
                text
                privacy1
                privacy2
                placeholderEmail
                lang
              }
            }
          }    
        }
      `}
      render={data => {
        const { title, text, privacy1, privacy2, placeholderEmail } = findLocalized(data.allNewsletterYaml, locale);
        return (
          <section id="newsletter" className="section newsletter text-center" aria-labelledby="region-newsletter">
            <div className="container">
              <div className="row" data-aos="fade-up">
                <div className="col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3">
                  <h1 id="region-newsletter" className="section__title">{title}</h1>
                  <p dangerouslySetInnerHTML={{__html: inlineLexer(text, [])}}></p>
                  <div className="newsletter__privacy">
                    {privacy1}<Link to="/privacy/" title="Privacy policy">{privacy2}</Link>.
                  </div>
                  <form id="form" name="newsletter" className="form">
                    <fieldset className="form__fieldset">
                      <div className="row">
                        <div className="col-sm-9">
                          <div className={`form__textwrapper ${error ? 'failed' : ''}`}>
                            <label htmlFor="email" className="form__label hide">E-mail</label>
                            <input type="email" name="email" value={email} placeholder={placeholderEmail} onChange={e => this.onChange(e)} className="form__text" />
                            {!!error && <div className="service-message"><FormattedMessage id="email-invalid" defaultMessage="Formato email non valido"/></div>}
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <button onClick={e => this.submit(e)} className="btn-cta btn-style-1">
                            <FormattedMessage id="iscriviti" />
                          </button>
                        </div>
                      </div>
                    </fieldset>
                  </form>
                </div>
              </div>
            </div>
            <Modal
              onHide={() => this.close()}
              aria-labelledby="modal-label"
              show={showModal}
              className="modal-box"
              renderBackdrop={props => <div {...props} className="modal-bg" />}
            >
              {success ?
                <p>
                  <FormattedMessage id="grazie-newsletter" />
                </p> :
                <div className="lds-roller">
                  <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
                </div>
              }
            </Modal>
          </section>
        );
      }}
    />
  }

}

export default injectIntl(Newsletter);
